import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateOptions } from "../utils/paginate.utils";
import { ActionInterface, ACTIONS_BASE } from "./actions.constants";
import { ColumnNames, FormField } from "./form.constants";
import { Validators } from "@angular/forms"

export const PLANES_COLUMN_NAMES : ColumnNames[]= [
  // { name: 'id', label: 'ID' },
  { name: 'codigo', label: 'Código' },
  { name: 'descripcion', label: 'Descripción' },
  { name: 'nivel.descripcion', label: 'Nivel' },
  { name: 'modalidad.descripcion', label: 'Modalidad' },
  { name: 'deleted_at', label: 'Fecha Baja', pipe: 'date' },
  { name: 'observacion', label: 'Observación' },
];

export const PLANES_FIELDS_CONFIG = [
  { name: 'id', type: 'number', label: 'ID', required: true },
  { name: 'nivel_id', type: 'number', label: 'Nivel', required: true },
  { name: 'modalidad_id', type: 'number', label: 'Modalidad', required: true },
  { name: 'codigo', type: 'text', label: 'Código', required: true },
  { name: 'descripcion', type: 'text', label: 'Descripción', required: true }
];

export const PLANES_ACTIONS: { [name: string]: ActionInterface } =

  {
    ...ACTIONS_BASE,
  "Materias" : {
    icon: "assignment",
    traslation: "Ver Materias",
    url: 'materias',
    type: 'link'
  }
}
export const PLANES_FIELDS_FORM : {[name: string]:FormField} = {
    descripcion: {
      label: 'Descripción',
      type: 'text',
      position: 2,
      validations: [Validators.required]
    },
    nivel_id: {
      label: 'Nivel',
      type: 'select',
      position: 3,
    },
    modalidad_id: {
      label: 'Modalidad',
      type: 'select',
      position: 4,
      validations: [Validators.required]
    },
    // nivel_id: {
    //   label: 'Nivel',
    //   type: 'select',
    //   position: 3,
    // },
    codigo: {
      label: 'Código',
      type: 'text',
      position: 1,
      validations: [Validators.required]
    }
  }
export const PLANES_PAGINATE_OPTIONS:PaginateOptions = {
  ...DEFAULT_PAGINATE_OPTIONS_LIST,
}
